<template>
    <Breadcrumbs main="Form Controls" title="Base Inputs" />
    <div class="container-fluid">
        <div class="row">
            <basicForm />
            <floatingForm />
            <selectSizing />
            <fileInput />
            <flatInput />
            <htmlInput />
            <floatingInput />
            <edgesInput />
            <raiseInput />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/basicForm.vue"))
const floatingForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/floatingForm.vue"))
const selectSizing = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/selectSizing.vue"))
const fileInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/fileInput.vue"))
const flatInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/flatInput.vue"))
const htmlInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/htmlInput.vue"))
const floatingInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/floatingInput.vue"))
const edgesInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/edgesInput.vue"))
const raiseInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/raiseInput.vue"))
</script>